import { defineComponent as _defineComponent } from 'vue'
import PictureComp from '@/components/picture/PictureComp.vue';
import AuthorPreview from '@/features/editorial/components/AuthorPreview.vue';

import { ArticleClickedData, BlockArticle } from '@/features/editorial/types/editorial-types';
import { useArticles } from '../../composables/useArticles';


export default /*#__PURE__*/_defineComponent({
  __name: 'RelatedArticles',
  props: {
    articleId: null
  },
  emits: ["articleClicked", "authorClicked"],
  setup(__props: any, { emit: emits }: { emit: ({
	(e: 'articleClicked', data: ArticleClickedData): void;
	(e: 'authorClicked', id: string | undefined): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
	articleId: number | null;
};





const { articles } = useArticles({
	articleId: props.articleId,
});

function handleArticleClick(article: BlockArticle, index: number) {
	const articleData = {
		slug: article.content.fullPath,
		articleType: article.content.articleType,
		index,
	};

	emits('articleClicked', articleData);
}

return { __sfc: true,props, emits, articles, handleArticleClick, PictureComp, AuthorPreview }
}

})